

document.addEventListener("DOMContentLoaded", function () {
  if (window.innerWidth >= 990) { // Desktop only
    const menus = document.querySelectorAll('header-menu details');

    menus.forEach(menu => {
      const summary = menu.querySelector('summary');
      const submenu = menu.querySelector('.header__submenu');

      if (summary && submenu) {
        // Disable Shopify's built-in click toggle
        summary.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
        });

        // Open dropdown on hover
        menu.addEventListener('mouseenter', () => {
          menu.setAttribute('open', true);
        });

        // Close dropdown on mouse leave
        menu.addEventListener('mouseleave', () => {
          menu.removeAttribute('open');
        });
      }
    });
  }
});







